/*
=========================================================
* Material Kit 2 React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React, { useEffect, useState } from "react";
import Grid2 from "@mui/material/Unstable_Grid2";

import axios from "axios";
import { CircularProgress } from "@mui/material";
import MKTypography from "../../components/MKTypography";
import MKBox from "../../components/MKBox";
import bgImage from "../../assets/images/backgrounds/bg-global012.png";
import JobsQueue from "./components/jobs-queue";
import MKButton from "../../components/MKButton";

// eslint-disable-next-line import/no-cycle
import MainLayout from "../MainLayout";
import Models from "./components/models";
import HTTP_API from "../../store/constant/httpApi";

const ComputingJobList = () => {
  const [ReturnJobs, setReturnJobs] = useState([]);

  const [NewJobClicked, setNewJobClicked] = useState(false);
  const handleNewJobClick = () => {
    setNewJobClicked(true);
  };
  const handleBackClicked = () => {
    setNewJobClicked(false);
  };

  const BreadcrumbsRoutes = [{ label: "Home", route: "/home" }, { label: "Computing" }];

  const fetchData = async (startKey) => {
    try {
      const response = await axios.post(HTTP_API.LUCC, {
        operation: "list_jobs",
        payload: { start_key: startKey },
      });
      const newJobs = response.data.Items;
      const newLastKey = response.data.LastEvaluatedKey;

      setReturnJobs((prevJobs) => [...prevJobs, ...newJobs]);

      // 如果有LastEvaluatedKey，继续发送请求
      if (newLastKey) {
        fetchData(newLastKey);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchData(null);
  }, []); // 注意: 这里的空数组表示只在组件挂载时触发

  return (
    <MainLayout breadcrumbsRoutes={BreadcrumbsRoutes}>
      <MKBox component="section" sx={{ height: "87vh", overflow: "auto" }}>
        {NewJobClicked ? null : (
          <MKBox
            width={1}
            height="25vh"
            bgColor="white"
            sx={{
              alignItems: "center",
              backgroundImage: ({
                palette: { dark, black },
                functions: { linearGradient, rgba },
              }) =>
                `${linearGradient(rgba(dark.main, 0.2), rgba(black.main, 0.6))}, url(${bgImage})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              display: "grid",
            }}
          >
            <MKBox
              mx={{ sm: 3, xl: 12, xxl: 24, xxxl: 36, xxxxl: 72 }}
              justifyContent={{ lg: "left", sm: "center" }}
            >
              <Grid2 container>
                <Grid2 xs={12} lg={7} xxl={6} xxxl={5}>
                  <MKTypography variant="h2" color="white" textAlign="left">
                    Near Real-time Earth Monitoring Empowered by AI and Cloud Computing for any
                    region in the HKH.
                  </MKTypography>
                </Grid2>
              </Grid2>
            </MKBox>
          </MKBox>
        )}
        <MKBox bgColor="white">
          <Grid2 container justifyContent="center">
            {NewJobClicked ? (
              <>
                <Models />
                <Grid2 xs={12} item my={2} justifyContent="center" sx={{ display: "flex" }}>
                  <MKButton variant="contained" color="error" onClick={handleBackClicked}>
                    Back
                  </MKButton>
                </Grid2>
              </>
            ) : (
              <>
                <Grid2 xs={12} item my={2}>
                  {ReturnJobs.length !== 0 ? <JobsQueue jobs={ReturnJobs} /> : null}
                </Grid2>
                {ReturnJobs.length === 0 ? (
                  <Grid2 xs={12} item my={2} justifyContent="center" sx={{ display: "flex" }}>
                    <CircularProgress />
                  </Grid2>
                ) : null}
                <Grid2 xs={12} item my={2} justifyContent="center" sx={{ display: "flex" }}>
                  <MKButton variant="contained" color="primary" onClick={handleNewJobClick}>
                    New Job
                  </MKButton>
                </Grid2>
              </>
            )}
          </Grid2>
        </MKBox>
      </MKBox>
    </MainLayout>
  );
};

export default ComputingJobList;
